import type { NormalizedCacheObject } from '@apollo/client'
import { ApolloClient, ApolloLink } from '@apollo/client'
import type { ErrorResponse } from '@apollo/client/link/error'
import { onError } from '@apollo/client/link/error'
import { SchemaLink } from '@apollo/client/link/schema'

import { schema } from '@acre/graphql/schema'
import { lutherErrorLink } from '@acre/utils'

import authRedirectErrorLink from './authRedirectErrorLink'
import cache from './cache'

const initApollo = () => {
  const client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
    link: ApolloLink.from([
      onError(lutherErrorLink),
      onError((error: ErrorResponse) => authRedirectErrorLink(error, client)),
      new SchemaLink({
        schema,
      }),
    ]),
    cache,
  })

  return client
}

export default initApollo
